import { P2GText } from '@parcel2go/core-ui';
import { useTaxName } from '@parcel2go/npm-p2g-app';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { toDisplayCurrency } from '~/lib/prices';
import { Currency } from '~/lib/types/basket-types';

type ItemPriceProps = {
  currency: Currency;
  subTotal: number;
  tax: number;
};

export const ItemPrice = ({ currency, subTotal: price, tax }: ItemPriceProps) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  const taxName = useTaxName();
  return (
    <P2GText variant="body1" colour="primary" fontWeight="bold">
      {tax
        ? t('PRICE_EXC', {
            defaultValue: '{{price}} exc {{taxName}}',
            price: toDisplayCurrency(currency, price),
            taxName: taxName
          })
        : toDisplayCurrency(currency, price)}
    </P2GText>
  );
};
